import { logger, deleteFSDirectory } from '@damofire/data-commons';
import { proxy, Remote, wrap } from 'comlink';
import { Observer, Subject } from 'rxjs';
import { OPERATION } from '../../des.dto';
import { Warehouse } from '../../warehouse/warehouse.dto';
import { WarehouseSyncStepContextEvent, WarehouseSyncStepTask, WarehouseSyncStepTaskContext } from '../executors';
import { WarehousesCleanupStepsWorker } from '../workers/warehouses-cleanup.steps.worker';
import { executeWorker, WarehouseSyncStepWorkerFactory } from './steps-utils';

class WarehouseCleanupSyncWorkerFactory implements WarehouseSyncStepWorkerFactory<WarehousesCleanupStepsWorker> {
  async createWorker(environment: any): Promise<[Worker, WarehousesCleanupStepsWorker | Remote<WarehousesCleanupStepsWorker>]> {
    if (environment.appConfig.watson.useWebworkers) {
      const warehouseWorker = new Worker(new URL('../workers/warehouses-cleanup.steps.worker', import.meta.url), { type: 'module' });
      const warehouseWorkerProxy = wrap<typeof WarehousesCleanupStepsWorker>(warehouseWorker);
      const workerService = await new warehouseWorkerProxy();
      return [warehouseWorker, workerService];
    }

    return [null, new WarehousesCleanupStepsWorker()];
  }
}

export class WarehousesCleanupSyncStepTask implements WarehouseSyncStepTask {
  constructor(private readonly environment: any) {}

  name(): string {
    return `CLEAN_WCL_TASK`;
  }

  async execute(ctx: WarehouseSyncStepTaskContext, listener: Observer<WarehouseSyncStepContextEvent>, taskBreaker: Subject<boolean>): Promise<void> {
    logger.debug('Executing warehouses cleanup sync task.');

    const callback = proxy((change: { data: Warehouse; operation: OPERATION }, buffer: ArrayBuffer): void => {
      if (this.environment.target === 'app') {
        deleteFSDirectory(change.data._id).catch(console.error);
      }
    });

    await executeWorker(ctx, this.environment, listener, new WarehouseCleanupSyncWorkerFactory(), taskBreaker, callback);
  }
}
